@if (!ready) {
  <app-spinner [centerVertically]="true"></app-spinner>
}
@if (ready) {
  <div class="translations-filters" id="top" [class.no-pointer]="saving?.length">
    <div class="row">
      <div class="col-2">
        <app-field-text
          [model]="FILTERS.term"
          (modelChange)="FILTERS.term = $event;"
          [label]="''"
          [instant]="true"
          [typeClass]="'type--search'"
          [placeholder]="'filter code...'">
        </app-field-text>
      </div>
      <!-- <div class="col-8 d-flex align-items-end">
      <app-field-single-check
        [model]="FILTERS.empty"
        (modelChange)="FILTERS.empty = $event;"
        [title]="'all languages empty (new records)'">
      </app-field-single-check>
    </div> -->
  </div>
</div>
<table class="translations-table">
  <tr>
    <th style="min-width: 400px; max-width: 400px;">code</th>
    @for (lang of languages; track lang) {
      <th [width]="thWidth">{{lang}}</th>
    }
  </tr>
  @for (string of strings | callback: filterStrings; track string; let $i = $index) {
    <tr [class.saving]="indexIsSaving($i)" class="saving--pre">
      <td style="min-width: 400px; max-width: 400px;">
        <div class="code" [title]="string.string">{{string.string}}</div>
      </td>
      @for (lang of languages; track lang) {
        <td>
          <input type="text" [(ngModel)]="string[lang]" [class.translation-empty]="!string[lang]" [class.translation-filled]="string[lang]" (keydown.enter)="$event.target.blur()" (blur)="indexIsChanged($i) && saveIndex($i)" (ngModelChange)="changeIndex($i)">
        </td>
      }
    </tr>
  }
</table>
}

<div (click)="toTop()" id="up" [class.shown]="helper.showUp">UP</div>